import { forwardRef, useEffect } from 'react';

// material-ui
import {
    FormHelperText,
    Grid,
    TextField,
    IconButton,
    DialogContent,
    Dialog,
    Zoom,
    Stack,
    Button
} from '@mui/material';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import useApi from 'hooks/useApi';
import MasterService from 'services/MasterService';
import sportsTypeSchema from 'utils/schema/SportsTypeSchema';
import { gridSpacing, USER_TYPE } from 'store/constant';

// third party
import { useFormik } from 'formik';

const Transition = forwardRef((props, ref) => <Zoom ref={ref} {...props} />);

export const CreateSportsTyper = ({ open, handleClose, selectedSportsType, userType, setReload }) => {

    const updateSportsType = () => {
        const formikValues = { ...formik.values };
        if (selectedSportsType) {
            updateStApi.execute(formikValues, selectedSportsType.uuid);
        } else {
            createStApi.execute(formikValues);
        }
    };

    const updateStHandler = () => {
        formik.resetForm()
        setReload(r => !r);
        handleClose();
    };

    const closeDialog = () => {
        formik.resetForm();
        handleClose();
    };

    const createStApi = useApi(MasterService.createSpotsType, updateStHandler, true);
    const updateStApi = useApi(MasterService.updateSportsTypeByUuid, updateStHandler, true);

    const formik = useFormik({
        initialValues: {
            code: selectedSportsType ? selectedSportsType.code : '',
            display_name: selectedSportsType ? selectedSportsType.display_name : '',
        },
        validationSchema: selectedSportsType ? sportsTypeSchema : sportsTypeSchema,
        onSubmit: updateSportsType
    });

    useEffect(() => {
        if (selectedSportsType) {
            formik.setFieldValue('code', selectedSportsType.code);
            formik.setFieldValue('display_name', selectedSportsType.display_name);
        }
    }, [selectedSportsType]);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={closeDialog}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent sx={{ p: 0 }}>
                <MainCard
                    title={`${selectedSportsType ? 'Edit' : 'Create'} ${userType === USER_TYPE[0].value ? 'Manager' : 'Customer'}`}
                    secondary={
                        <IconButton onClick={closeDialog} size="large" aria-label="Close User">
                            <HighlightOffTwoToneIcon fontSize="small" />
                        </IconButton>
                    }>
                    <Grid container spacing={gridSpacing}>
                        <Grid item sm={6} md={12}>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Code"
                                        name="code"
                                        error={Boolean(formik.touched.code && formik.errors.code)}
                                        value={formik.values.code}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.touched.code && formik.errors.code && (
                                        <FormHelperText error id="standard-weight-helper-text-value-user">
                                            {formik.errors.code}
                                        </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Dislay Name*"
                                        name="display_name"
                                        error={Boolean(formik.touched.display_name && formik.errors.display_name)}
                                        value={formik.values.display_name}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.touched.display_name && formik.errors.display_name && (
                                        <FormHelperText error id="standard-weight-helper-text-display_name-user">
                                            {formik.errors.display_name}
                                        </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                                        <Button
                                            color="error"
                                            onClick={closeDialog}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            color="secondary"
                                            variant="contained"
                                            onClick={formik.handleSubmit}
                                        >
                                            {selectedSportsType ? 'Update' : 'Create'} SportsType
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </MainCard >
            </DialogContent>
        </Dialog >
    );
};
